import { Switch } from "@mui/material";
import { LocalSettingsDTO } from "../../../../models/localSettings/localSettings.request";

interface DefaultSettingsProps {
    defaultSettings: LocalSettingsDTO;
    onSettingsChange: (updatedSettings: LocalSettingsDTO) => void;
}

export default function DefaultSettings({ defaultSettings, onSettingsChange }: DefaultSettingsProps) {

    return (
        <div className="default-settings-block">
            <div className="admin-settings-box-div default-settings-div">
                <div className="list-header-info">
                    <div className="list-header-title">Opšta podešavanja</div>
                    <div className="list-header-description">
                        Podesite ostala podešavanja lokala<br />
                    </div>
                </div>
                <div className="div-block-103">
                    <div>
                        <div className="text-block-52">Dugme „Dodaj u korpu &quot;</div>
                        <div className="description-text fs-0-75">Prikazuje dugme za dodavanje stavki u korpu na karticama proizvoda. Isključite ovo ako vaš lokal nema opciju online naručivanja i koristite meni isključivo za pregled.</div>
                    </div>
                    <Switch
                        checked={defaultSettings.showAddToCartButton}
                        onChange={(e) => onSettingsChange({ ...defaultSettings, showAddToCartButton: e.target.checked })}
                    />
                </div>
            </div>
        </div>

    );
}